import { useState } from "react";
import { FriendList } from "./FriendList.1";
import { FormAddFriend } from "./FormAddFriend";
import { FormSplitBill } from "./FormSplitBill";

const initialFriends = [
  {
    id: 118836,
    name: "Clark",
    image: "https://i.pravatar.cc/48?u=118836",
    balance: -7,
  },
  {
    id: 933372,
    name: "Sarah",
    image: "https://i.pravatar.cc/48?u=933372",
    balance: 20,
  },
  {
    id: 499476,
    name: "Anthony",
    image: "https://i.pravatar.cc/48?u=499476",
    balance: 0,
  },
];

export function Button({ children, onClick }) {
  return (
    <>
      <button className="button" onClick={onClick}>
        {children}
      </button>
    </>
  );
}
export default function App() {
  const [isOpen, setIsOpen] = useState(false);

  const [friends, setFriends] = useState(initialFriends);

  const [selectedFriend, setSelectedFriend] = useState(null);

  function handelAddNewFriend(newFriend) {
    setFriends((prevFriend) => [...prevFriend, newFriend]);
  }

  function handelSelection(friend) {
    // setSelectedFriend(friend);
    setSelectedFriend((cur) => (cur?.id === friend.id ? null : friend));
    setIsOpen(false);
  }
  function handelSplitBill(value) {
    setFriends((friends) =>
      friends.map((friend) =>
        friend.id === selectedFriend.id
          ? { ...friend, balance: friend.balance + value }
          : friend
      )
    );
    setSelectedFriend(null);
  }

  function handelButton() {
    setIsOpen((e) => !e);
  }
  return (
    <>
      <div className="app">
        <div className="sidebar">
          <FriendList
            onSelection={handelSelection}
            selectedFriend={selectedFriend}
            friends={friends}
          />
          {isOpen && (
            <FormAddFriend
              onAddFriend={handelAddNewFriend}
              onClose={handelButton}
            />
          )}
          <Button onClick={handelButton}>
            {isOpen ? "Close" : "Add Friend"}
          </Button>
        </div>
        {selectedFriend && (
          <FormSplitBill
            selectedFriend={selectedFriend}
            onSplitBill={handelSplitBill}
          />
        )}
      </div>
    </>
  );
}
